import PropTypes from 'prop-types';

const SVG = ({
  style = {
    fill: '#000000',
  },
}) => (
  <svg style={style} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60.2">
    <path d="M14.63 53.74a8.21 8.21 0 118.19-8.21 8.21 8.21 0 01-8.19 8.21zm0-14.07a5.86 5.86 0 105.84 5.86 5.86 5.86 0 00-5.84-5.86zM30 38.31a8.21 8.21 0 118.18-8.21A8.2 8.2 0 0130 38.31zm0-14.07a5.86 5.86 0 105.83 5.86A5.85 5.85 0 0030 24.24zM45.4 22.86a8.21 8.21 0 118.19-8.21 8.2 8.2 0 01-8.19 8.21zm0-14.06a5.86 5.86 0 105.84 5.85A5.85 5.85 0 0045.4 8.8z" />
    <path d="M14.84 60.2h-2.31c-4.88-.07-9.41-.17-11-.69a1.19 1.19 0 01-.76-.77C.2 57.1.1 52.52 0 47.61v-1.84a14.77 14.77 0 019.6-14.13c2.23-.82 5.79-4.44 6.67-6.77a14.8 14.8 0 018.51-8.54c2.33-.89 5.93-4.46 6.75-6.7a14.8 14.8 0 015.54-7.09A14.34 14.34 0 0145.63 0h2c4.81.06 9.27.15 10.9.66a1.18 1.18 0 01.77.77c.51 1.64.6 6.12.66 11v2a14.74 14.74 0 01-9.6 14.12c-2.23.83-5.79 4.44-6.67 6.78a14.8 14.8 0 01-8.51 8.54c-2.33.89-5.93 4.46-6.75 6.7a14.59 14.59 0 01-13.59 9.63zm-12-2.83a92.53 92.53 0 009.74.44h1.87a12.21 12.21 0 0011.82-8.09c1.06-2.87 5.16-6.95 8.12-8.08a12.42 12.42 0 007.15-7.17c1.12-3 5.19-7.09 8-8.15a12.42 12.42 0 008.07-11.87v-2a94.12 94.12 0 00-.41-9.65 95.94 95.94 0 00-9.59-.42h-2a12.41 12.41 0 00-11.83 8.09c-1.06 2.87-5.16 7-8.12 8.08a12.42 12.42 0 00-7.15 7.17c-1.12 3-5.19 7.09-8 8.15a12.41 12.41 0 00-8.16 11.85v1.86a96.2 96.2 0 00.44 9.79zM50 27.45z" />
  </svg>
);

SVG.propTypes = {
  style: PropTypes.object.isRequired,
};

export default SVG;
